import React from 'react'

export default function MailSupport() {
  return <a href="mailto:support@bracketchallenge.world" target="_blank">support@bracketchallenge.world</a>
}
